import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardHeader,
  Divider,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
  Typography,
  makeStyles,
  CircularProgress,
} from '@material-ui/core';
import EnhancedTableHead from '../EnhancedTableHead';

const useStyles = makeStyles({
  tableCell: {
    cursor: 'pointer',
  },
  loader: {
    position: 'absolute !important',
    top: '20px',
    left: '45%',
  },
  tableBody: {
    position: 'relative',
    height: '60px',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
});

const headCells = [
  { id: 'no', numeric: false, disablePadding: false, label: 'No' },
  {
    id: 'modification_date',
    numeric: false,
    disablePadding: false,
    label: 'Last Job Date',
    sortable: true,
  },
  {
    id: 'total_commission',
    numeric: false,
    disablePadding: false,
    label: 'Total Commission',
    sortable: true,
  },
  {
    id: 'total_tip',
    numeric: false,
    disablePadding: false,
    label: 'Total Tips',
    sortable: true,
  },
  {
    id: 'total_received',
    numeric: false,
    disablePadding: false,
    label: 'Total Received',
    sortable: true,
  },
  {
    id: 'money_to_receive',
    numeric: false,
    disablePadding: false,
    label: 'Money to receive',
    sortable: true,
  },
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const TransactionDetail = ({ transactionDetail, loading, wallet }) => {
  const classes = useStyles();
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('calories');

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  return (
    <Card>
      {!loading && transactionDetail && (
        <CardHeader
          title={
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span>Transaction Detail | Provider: Abs</span>
              <span
                color="textPrimary"
                style={{ marginLeft: 20, fontSize: 20, fontWeight: 'bold' }}
              >
                WALLET BALANCE : {transactionDetail[0]?.money_to_receive}€
              </span>
            </div>
          }
        />
      )}
      <Divider />
      <CardContent>
        <Table>
          <EnhancedTableHead
            classes={classes}
            order={order}
            orderBy={orderBy}
            headCells={headCells}
            onRequestSort={handleRequestSort}
          />
          <TableBody className={classes.tableBody}>
            {loading && <CircularProgress className={classes.loader} />}
            {!loading &&
              transactionDetail &&
              stableSort(transactionDetail, getComparator(order, orderBy))
                .slice(page * limit, page * limit + limit)
                .map((user, index) => (
                  <TableRow hover key={user.id}>
                    <TableCell>{page * limit + index + 1}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          alignItems: 'center',
                          display: 'flex',
                        }}
                      >
                        <Typography color="textPrimary" variant="body1">
                          {user.modification_date}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{user.total_commission}€</TableCell>
                    <TableCell>{wallet[0].total_tip}€</TableCell>
                    <TableCell>{user.total_received}€</TableCell>
                    <TableCell>{user.money_to_receive}€</TableCell>
                  </TableRow>
                ))}
            {!loading && !transactionDetail && (
              <p className={classes.loader}>No Data</p>
            )}
          </TableBody>
        </Table>
      </CardContent>
      <TablePagination
        component="div"
        count={transactionDetail ? transactionDetail.length : 0}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleLimitChange}
        page={page}
        rowsPerPage={limit}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
      />
    </Card>
  );
};

TransactionDetail.propTypes = {
  transactionDetail: PropTypes.array,
  wallet: PropTypes.array,
  loading: PropTypes.bool,
};

export default TransactionDetail;
